<template>
    <div class="pd-page">
        <div class="pd-page-header">再生塑料加工-MES系统</div>
        <div class="pd-page-body">
            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>企业类型
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>再生塑料加工</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户介绍
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>某环境资源有限公司，立足于固体废物治理及废弃资源综合利用行业，以回收的废塑料、废旧纺织品为主要原料，以其衍生的再生聚酯新材料为产品基础，以再生涤纶短纤维和再生专用料为主导产品，以差别化再生涤纶短纤维、改性再生专用料等循环利用新材料为新产品发展方向，致力于再生涤纶短纤维及再生专用料的研发、制造和销售。</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户痛点
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>采用纸质日报单，生产进度填报不及时、不准确</li>
                        <li>产成品、半成品、原材料无法追溯，财务只能按月核算利润，亏损点无法定位</li>
                        <li>数据整理和分析工作量大，效率低，人员成本高</li>
                        <li>质量检测与产成率无法联动，导致对产成率无法精准分析</li>
                        <li>成本核算数据不准确、核算时间滞后，发现问题时亏损已经产生</li>
                        <li>对供应商信誉、质量无法精准控制，劣质供应商却享受优质待遇</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>解决方案
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>数字化生产填报，确保生产数据实时准确上报，生产日报自动生成</li>
                        <li>核心环节自动采集，减少人为干扰</li>
                        <li>构建批次管理体系：原材料一质量检验一生产加工一成品入出库全过程可追溯</li>
                        <li>质检数据线上化：实现扣杂率与产成率对比分析，以“智”提“质”</li>
                        <li>生产过程透明化：实现生产过程可追溯、物料可追溯、质量可追溯</li>
                        <li>生产数据精益化：建立单吨成本统计、生产损益分析、供应链利润分析等分析模型</li>
                        <li>供应商评价管理：对供货质量、响应速度综合评分，确保高质量供应商享受高质量待遇</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>效果/价值
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>生产数据采集路径广，实现动态实时掌控、协同管理</li>
                        <li>异常情况响应及处理效率提高50%以上</li>
                        <li>质检效率提高，误差率下降，良品率提升</li>
                        <li>制成率的准确度提高30%以上</li>
                        <li>报表数据实时汇总，速度提升70%</li>
                        <li>Mes上线半年后，客户业务利润率增加2%左右</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "casePage1"
}
</script>

<style scoped>

</style>
